import React from "react"
import { useExpenseFormContext } from "~Components/modals/expenseCreateForm.context"
import { useAreCardsActivated } from "~Shared/hooks/corporate.hooks"
import { ResponsiveFormLayout } from "../../layout/ResponsiveFormLayout"
import { ExpenseCommonInputFieldsForm } from "./commonInputFields/ExpenseCommonInputFieldsForm"
import { OfferDocumentUploadForm } from "./commonInputFields/offerDocumentUpload.form"
import { PaymentOptionSelector } from "./commonInputFields/paymentOptionSelector.form"
import { SubscriptionExpenseForm } from "./subscriptionExpenseFields"

export const SubscriptionRequestForm = () => {
    const [{ isPreApprovedSubscription, isNew, updateExpense, expenseForm }] = useExpenseFormContext()
    const cardsActive = useAreCardsActivated()

    return (
        <ResponsiveFormLayout
            leftSide={
                <>
                    {cardsActive && isNew && <PaymentOptionSelector />}
                    <SubscriptionExpenseForm />
                    <ExpenseCommonInputFieldsForm showPerformancePeriod={false} showCurrency={false} />
                    {!isPreApprovedSubscription && <OfferDocumentUploadForm isNew={isNew} updateExpense={updateExpense} expenseForm={expenseForm} />}
                </>
            }
        />
    )
}
